import { render, staticRenderFns } from "./regulationAdd.vue?vue&type=template&id=0b8cf49a&scoped=true&"
import script from "./regulationAdd.vue?vue&type=script&lang=js&"
export * from "./regulationAdd.vue?vue&type=script&lang=js&"
import style0 from "./regulationAdd.vue?vue&type=style&index=0&id=0b8cf49a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8cf49a",
  null
  
)

export default component.exports